module.exports = __webpack_public_path__ + "img/category_4.a785d683.jpg";